import React, { Component } from "react"
import { Link } from "react-router-dom"
import { connect } from "react-redux"
import { bindActionCreators } from "redux"

import { actions as appActions } from "../../modules/appModule"
import { COLOR } from "../../modules/constants"

import DashboardNavbar from "../../components/layout/DashboardNavbar"
import SetNewPasswordForm from "../../forms/SetNewPasswordForm"
import AnonPage, { Content } from "../../components/AnonPage"
import Footer from "../../components/Footer"

class SetNewPassword extends Component {
  render() {
    const { app, resendResetResult, setNewPassError, urlSource } = this.props
    return (
      <React.Fragment>
        <DashboardNavbar title="Set New Password" backLink />

        <AnonPage>
          <Content scroll>
            <div className="form-page">
              <div className="form-cell">
                <div className="form-wrapper">
                  <div className="information">
                    We've sent you an email with a confirmation code to let you to set a new password<br /><br /><br />
                  </div>
                  <SetNewPasswordForm onSubmit={form => app.setNewPassword(form)} />
                  <p className="error-message">
                    {setNewPassError}
                  </p>
                  <div className="alternative-link">
                    <Link onClick={(event) => {
                      app.resendResetCode()
                      event.preventDefault()
                      return false
                    }} to="" style={{ color: COLOR.BRAND.STD }} >Re-send password reset code</Link>
                  </div>
                  <p className="error-message">
                    {resendResetResult}
                  </p>
                </div>
              </div>
            </div>
          </Content>
        </AnonPage>

        <Footer urlSource={urlSource} />
      </React.Fragment>
    )
  }
}

const mapStateToProps = ({ app, common }) => {
  return {
    resendResetResult: app.resendResetResult,
    setNewPassError: app.setNewPassError,
    urlSource: common.urlSource,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    app: bindActionCreators(appActions, dispatch),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(SetNewPassword)

